import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '',
    name: 'Page-Template',
    component: () => import('@/layouts/PageTemplate.vue'),
    children: [
      {
        path: 'special-offer',
        name: 'Special-Offer',
        component: () => import('@/views/page/SpecialOffer'),
        children: [
          {
            path: ':id',
            name: 'Coupon',
            component: () => import('@/views/page/SpecialOffer/Coupon.vue'),
          },
        ],
      },
      {
        path: 'about',
        name: 'Service',
        component: () => import('@/views/page/Service.vue'),
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/page/News.vue'),
      },
      {
        path: 'terms',
        name: 'Terms',
        component: () => import('@/views/page/Terms.vue'),
      },
      {
        path: 'privacy',
        name: 'Privacy',
        component: () => import('@/views/page/Privacy.vue'),
      },
      {
        path: 'FAQ',
        name: 'QA',
        component: () => import('@/views/page/QA.vue'),
      },
      {
        path: 'partners',
        name: 'Partners',
        component: () => import('@/views/page/PartnersPage.vue'),
      },
      {
        path: 'upgrade',
        name: 'Upgrade',
        component: () => import('@/views/page/Upgrade.vue'),
      },
      {
        path: '/app/download',
        name: 'Download',
        component: () => import('@/views/page/Download.vue'),
      },
    ],
  },
  {
    path: '*',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
];

// eslint-disable-next-line no-unused-vars
const scrollBehavior = (to, from, savedPosition) => new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve({ x: 0, y: 0 });
  }, 500);
});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
});

// let loader = () => {};

router.beforeEach((to, from, next) => {
  // console.log(to.query);
  if (to.query.type) {
    const { type } = to.query;
    if (type === 'news') {
      router.push({ name: 'News' });
    } else if (type === 'coupon') {
      const { id } = to.query;
      router.push({ name: 'Coupon', params: { id } });
    }
  }
  next();
});
// router.afterEach(() => {
//   loader.hide();
// });

export default router;
